export default class Storage{
  static storage_name = "trend2b";

  static __getName(name, temp=false){
    return `${this.storage_name}:${temp?"temp:":""}${name}`;
  }

  static set(name, value){
    localStorage.setItem(this.__getName(name),value);
  }

  static setTemp(name, value){
    localStorage.setItem(this.__getName(name,true),value);
  }

  static setObject(name, value){
    this.set(name, JSON.stringify(value))
  }

  static setTempObject(name, value){
    this.setTemp(name, JSON.stringify(value))
  }

  static get(name){
    let r = localStorage.getItem(this.__getName(name));
    if(!r){
      r = localStorage.getItem(this.__getName(name,true));
      if(!!r){
        localStorage.removeItem(this.__getName(name,true));
      }
    }
    return r;
  }

  static getObject(name){
    let data = this.get(name);
    try {
      return JSON.parse(data);
    } catch (error) {
      return null;
    }
  }

  static remove(name){
    localStorage.removeItem(this.__getName(name))
  }

  static clear(){
    Object.keys(localStorage).forEach(k=>{
      if(k.indexOf(this.storage_name) !== -1){
        localStorage.removeItem(k);
      }
    })
  }
}